export default {
  default: () => import("/builds/projectowners/lawofficesystem/layouts/default.vue").then(m => m.default || m),
  "law-office": () => import("/builds/projectowners/lawofficesystem/layouts/law-office/index.vue").then(m => m.default || m)
}